"use strict";
/* globals module */
/**
 * @module notificationsSubscriptionsAnonymousClient
 * @description  Notifications Subscriptions Anonymous Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsSubscriptionsAnonymousClient` uses `notificationsSubscriptionsAnonymousRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var NotificationsSubscriptionsAnonymousClient = /** @class */ (function () {
    function NotificationsSubscriptionsAnonymousClient(notificationsSubscriptionsAnonymousRoute, notificationsSubscriptionsAnonymousBatchClient, apiClient) {
        this.notificationsSubscriptionsAnonymousRoute = notificationsSubscriptionsAnonymousRoute;
        this.notificationsSubscriptionsAnonymousBatchClient = notificationsSubscriptionsAnonymousBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsSubscriptionsAnonymousClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsSubscriptionsAnonymousRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsSubscriptionsAnonymousClient.prototype, "batch", {
        get: function () {
            return this.notificationsSubscriptionsAnonymousBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create anonymous subscription action has been performed; this action creates a new anonymous subscription resource.
     * @method
     * @param data An AnonymousSubscription object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create anonymous subscription action has been performed.
     * @example notificationsSubscriptionsAnonymousClient.create({
                    channel: '<channel-name>',
                    registrationId: '<registration-id>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsSubscriptionsAnonymousClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of anonymous subscription resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example notificationsSubscriptionsAnonymousClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>',
                    channels: '<channel-name1>,<channel-name2>',
                    registrationIds: '<registration-id1>,<registration-id2>',
                    embed: '<embed>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsSubscriptionsAnonymousClient.prototype.find = function (options) {
        return this.apiClient.get(this.notificationsSubscriptionsAnonymousRoute.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified anonymous subscription resource.
     * @method
     * @param id The subscription identifier which uniquely identifies AnonymousSubscription resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example notificationsSubscriptionsAnonymousClient.get('<subscription-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsSubscriptionsAnonymousClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.notificationsSubscriptionsAnonymousRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the remove anonymous subscription action has been performed. This action will remove a anonymous subscription resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsSubscriptionsAnonymousRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(subscription);
     * var uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data The subscription identifier used to delete specific subscription resource in the system.
     * @returns A promise that is resolved once the remove anonymous subscription action has been performed.
     * @example // subscription is a resource previously fetched using get action.
                        notificationsSubscriptionsAnonymousClient.remove(subscription)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     */
    NotificationsSubscriptionsAnonymousClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the update anonymous subscription action has been performed; this action updates a anonymous subscription resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsSubscriptionsAnonymousRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(subscription);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An object used to update specified AnonymousSubscription resource.
     * @returns A promise that is resolved once the update anonymous subscription action has been performed.
     * @example // subscription is a resource previously fetched using get action.
                    subscription.channel = '<channel-name>';
                    notificationsSubscriptionsAnonymousClient.update(subscription)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     */
    NotificationsSubscriptionsAnonymousClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b, _c;
    NotificationsSubscriptionsAnonymousClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsAnonymousRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsAnonymousBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsAnonymousRoute !== "undefined" && _1.NotificationsSubscriptionsAnonymousRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsSubscriptionsAnonymousBatchClient !== "undefined" && _1.NotificationsSubscriptionsAnonymousBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], NotificationsSubscriptionsAnonymousClient);
    return NotificationsSubscriptionsAnonymousClient;
}());
exports.NotificationsSubscriptionsAnonymousClient = NotificationsSubscriptionsAnonymousClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
